export const LocalStorageKeys = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
} as const;
